<template>
  <div>
    <div class="status-box">
      <div class="img-box">
        <img :src="cover_src" alt="" />
        <p class="">{{message}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default { 
  data() {
    return {
      // cover_src:''
    };
  }, 
  methods: {
    
  },
  mounted() {},
  computed:{
    cover_src(){
        return require(`../../assets/images/team/${this.award?'success':'fail'}.png`)
    }
  },
  props:['message','award']
};
</script> 

<style>

</style>
